export default {
  WEBHOOKS: (state) => state.webhooks,
  WEBHOOKS_TRIGGERS: (state) => state.webhooksTriggers,
  ADD_UPDATE_WEBHOOK_LOADING: (state) => state.addUpdateWebhookLoading,
  WEBHOOKS_LOADING: (state) => state.webhooksLoading,
  REMOVE_WEBHOOK_LOADING: (state) => state.removeWebhookLoading,
  WEBHOOK: (state) => state.webhook,
};
